import '@/assets/ai-modal.css';
import { AI_ASSISTANT_AVATAR } from '@/app/common/constants/ai';

type AiAssistantLoadingIconProps = {
  className?: string;
};

export function AiAssistantLoadingIcon({ className }: AiAssistantLoadingIconProps) {
  return (
    <div className={['ai-analysis-loading-icon-wrap', className].filter(Boolean).join(' ')}>
      <span className="ai-analysis-loading-ring" aria-hidden="true" />
      <img src={AI_ASSISTANT_AVATAR} alt="" className="ai-analysis-loading-avatar" />
    </div>
  );
}
